var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { INSURER_CONFIG } from '@shared/insurer';
import { allCountingTabs } from '@shared/types/api/backoffice';
import { uuidFromIri } from '@shared/utils/iri';
import { downloadOnlineFile } from '@shared/files/downloadFile';
const claim = namespace('claim');
let ChiffrageId = class ChiffrageId extends Vue {
    constructor() {
        super(...arguments);
        this.isSendingEmail = false;
        this.isDownloadingPdf = false;
        this.download = downloadOnlineFile.bind(this.$axios);
        /*
      
        IMPORTANT
      
        Pour fermer l'iframe, le selfcare doit envoyer un message "iframe:close" à la fenêtre parente, comme ceci :
      
        window.parent.postMessage('iframe:close', '*');
      
        */
        this.messageListener = async (event) => {
            var _a;
            if (event.data === 'iframe:close') {
                await this.$store.dispatch('claim/selectClaim', {
                    id: this.id,
                    edit: false,
                    identifier: (_a = INSURER_CONFIG.backoffice) === null || _a === void 0 ? void 0 : _a.claimUrlIdentifier,
                });
                this.$goToLocalePath({ name: 'chiffrage-id-chiffrage', params: { id: this.id } });
            }
        };
    }
    get pageName() {
        return this.getRouteBaseName(this.$route);
    }
    get id() {
        return this.$route.params.id;
    }
    get claimId() {
        return this.info ? uuidFromIri(this.info.claim.id) : '';
    }
    get caseNumber() {
        return this.info ? this.info.claim.caseNumber : '';
    }
    get tabs() {
        return allCountingTabs.map((tab) => {
            const page = `chiffrage-id-${tab}`;
            return {
                tab,
                page,
                title: this.$tc(`pages.chiffrage_id.tabs.${tab}`),
                isCurrent: this.pageName === page,
            };
        });
    }
    async downloadPdf() {
        if (this.isDownloadingPdf || !this.claimId)
            return;
        try {
            this.isDownloadingPdf = true;
            await this.download(`/pdf/counting-report/${this.$i18n.locale}/${this.claimId}`);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
        }
        finally {
            this.isDownloadingPdf = false;
        }
    }
    mounted() {
        window.addEventListener('message', this.messageListener);
        if (this.pageName === 'chiffrage-id') {
            this.$goToLocalePath({
                name: `chiffrage-id-dommages`,
                params: this.$route.params,
                query: this.$route.query,
                hash: this.$route.hash,
            });
        }
        // Watch for page name changes to send resumption step when iframe becomes visible
        this.$watch('pageName', () => {
            this.sendResumptionStepToIframe();
        });
    }
    sendResumptionStepToIframe() {
        var _a, _b, _c, _d;
        if (this.pageName !== 'chiffrage-id-declaration' || !((_c = (_b = (_a = this.info) === null || _a === void 0 ? void 0 : _a.claim) === null || _b === void 0 ? void 0 : _b.type) === null || _c === void 0 ? void 0 : _c.trigram)) {
            return;
        }
        const trigram = this.info.claim.type.trigram;
        const resumptionSteps = (_d = INSURER_CONFIG.backoffice) === null || _d === void 0 ? void 0 : _d.resumptionSteps;
        if (!resumptionSteps || !resumptionSteps[trigram]) {
            // No resumption step configured for this trigram, use default behavior
            return;
        }
        const resumptionStep = resumptionSteps[trigram];
        // Wait a bit for iframe to be ready and have its listener installed
        setTimeout(() => {
            const iframe = document.querySelector('.counting-iframe');
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage({ type: 'iframe:navigate', step: resumptionStep }, '*');
            }
        }, 100);
    }
    async sendPdfByEmail() {
        if (!this.claimId) {
            return;
        }
        this.isSendingEmail = true;
        await this.$axios.$post(`/send-email/pdf-counting-recap/${this.claimId}`);
        this.isSendingEmail = false;
    }
    beforeUnmount() {
        window.removeEventListener('message', this.messageListener);
    }
};
__decorate([
    claim.State('info')
], ChiffrageId.prototype, "info", void 0);
__decorate([
    claim.State('initialClaim')
], ChiffrageId.prototype, "initialClaim", void 0);
__decorate([
    claim.State('contract')
], ChiffrageId.prototype, "contract", void 0);
__decorate([
    claim.State('isContractLoading')
], ChiffrageId.prototype, "isContractLoading", void 0);
__decorate([
    claim.State('isEditingClaim')
], ChiffrageId.prototype, "isEditingClaim", void 0);
__decorate([
    claim.State('isInfoLoading')
], ChiffrageId.prototype, "isInfoLoading", void 0);
__decorate([
    claim.State('error')
], ChiffrageId.prototype, "error", void 0);
__decorate([
    claim.Getter('isClaimUpdating')
], ChiffrageId.prototype, "isClaimUpdating", void 0);
__decorate([
    claim.State('hasPendingChanges')
], ChiffrageId.prototype, "hasPendingChanges", void 0);
__decorate([
    claim.Action('selectClaim')
], ChiffrageId.prototype, "selectClaim", void 0);
__decorate([
    claim.Action('addDraftChanges')
], ChiffrageId.prototype, "addDraftChanges", void 0);
__decorate([
    claim.Action('edit')
], ChiffrageId.prototype, "edit", void 0);
__decorate([
    claim.Action('cancelEdition')
], ChiffrageId.prototype, "cancelEdition", void 0);
__decorate([
    claim.Action('saveChanges')
], ChiffrageId.prototype, "saveChanges", void 0);
__decorate([
    claim.State('magicLink')
], ChiffrageId.prototype, "magicLink", void 0);
ChiffrageId = __decorate([
    Component({
        middleware: 'hasAccess',
        async asyncData({ route, store, error }) {
            var _a, _b, _c, _d, _e;
            if (((_b = (_a = store.state.claim.info) === null || _a === void 0 ? void 0 : _a.claim) === null || _b === void 0 ? void 0 : _b[(_d = (_c = INSURER_CONFIG.backoffice) === null || _c === void 0 ? void 0 : _c.claimUrlIdentifier) !== null && _d !== void 0 ? _d : 'id']) ===
                route.params.id) {
                return;
            }
            await store.dispatch('claim/selectClaim', {
                id: route.params.id,
                edit: false,
                identifier: (_e = INSURER_CONFIG.backoffice) === null || _e === void 0 ? void 0 : _e.claimUrlIdentifier,
            });
            if (store.state.claim.error) {
                error({
                    message: store.state.claim.error,
                    statusCode: 404,
                    path: route.fullPath,
                });
            }
        },
        nuxtI18n: {
            paths: {
                en: '/counting/:id',
            },
        },
    })
], ChiffrageId);
export default ChiffrageId;
